export default __webpack_public_path__ + "static/media/corner-hummingbird.4afbeb55.webp";